import { fetchAtlassianAccountIDByEmail } from '@atlassian/temp-proxies';
import { get } from 'lodash';

export const validateEmailByAtlassianAccount = async (email: string) => {
  const responseObject = { id: '', error: '' };
  try {
    const payload: { emails: Array<string> } = {
      emails: [email],
    };
    const response = await fetchAtlassianAccountIDByEmail(payload);
    responseObject.id = get(response, '[0].account_id', '');
  } catch (err) {
    responseObject.error = 'Failed to fetch Atlassian Account ID';
  }
  return responseObject;
};
